import * as _ from "lodash";
import {BaseModifyDashboardWidgetViewOptions} from "../../_BaseModifyWidgetView";
import {ModifyNoOptionsWidgetView} from "../GenericNoOptions";

export class ModifyDefaultChartWidgetView extends ModifyNoOptionsWidgetView {

    private dashboardCategory: Backbone.Model;

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any> _.extend({
            className: 'widget-type-default-chart'
        }, options));

        this.dashboardCategory = this.options.dashboardCategoryCollection.findWhere({'minimal': 1});

        this.options.widget = new this.options.dashboardWidgetCollection.model({
            dashboard_id: this.options.dashboardId,
            params: [],
            dashboard_category_id: this.dashboardCategory.get('id'),
            type_id: this.options.widgetTypeId,
            type: this.options.widgetType,
            app_type: this.options.appType,
            app_type_id: this.options.appTypeId,
            order: this.getWidgetOrder()
        });
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/genericnooptions/defaultchartwidget/DefaultChart.ts